module.exports = __webpack_public_path__ + "media/images/provider-audio-active-d87f812494daa0171494ac092007982a.svg";